import { useEffect, useState } from "react";
import { Percent } from "lucide-react";
import api from "@/lib/api";
import { PageHeader } from "@/components/ui-helpers";

export default function CommissionPage() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/marketplace/seller/commissions").then((r) => setData(r.data)).catch(() => setData({ commissions: [] })); }, []);
  const rate = (r) => r == null ? "As per agreement" : `${r}%`;

  return (
    <div data-testid="commission-page">
      <PageHeader title="Commission" icon={Percent} subtitle="Marketplace commission applicable to your products. Set by Suffle; historical orders keep their original rate." />
      {data?.default_rate != null && <p className="mb-3 text-sm text-slate-500">Default marketplace commission: <b>{data.default_rate}%</b></p>}
      {data && data.commissions.length === 0 && <div className="rounded-2xl border border-dashed border-slate-300 bg-white p-12 text-center text-sm text-slate-500" data-testid="commission-empty">No products yet.</div>}
      <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white" data-testid="commission-list">
        {(data?.commissions || []).map((c) => (
          <div key={c.product_id} className="flex items-center justify-between gap-3 border-b border-slate-100 p-3 last:border-0" data-testid={`comm-${c.product_id}`}>
            <div className="min-w-0"><p className="truncate text-sm font-medium text-slate-800">{c.name}</p>{c.price != null && <p className="text-xs text-slate-400">₹{Math.round(c.price)}</p>}</div>
            <span className="rounded-full bg-blue-50 px-3 py-1 text-xs font-semibold text-blue-700">{rate(c.commission_rate)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
